import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    fontSize: toRem(14),
    position: 'relative',

    [theme.breakpoints.up('md')]: {
        fontSize: toRem(16)
    },

    '&:hover': {
        cursor: 'pointer',

        '.ItemImage img': {
            transform: 'scale(1.25, 1.25)'
        },

        '.Arrow': {
            opacity: 1,
            right: 0
        }
    },

    '& .blockLink': {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        textIndent: -9999,
        zIndex: 1
    },

    '& .ItemImage': {
        borderRadius: 4,
        overflow: 'hidden',
        maxWidth: 520,
        marginBottom: toRem(18),

        '& > div': {
            height: 'auto !important'
        },

        img: {
            transition: 'transform 0.5s ease'
        }
    },

    '& .title': {
        fontSize: toRem(19),
        fontWeight: 600
    },

    '& .specification': {
        borderBottom: `1px solid ${theme.colors.goldDark}`,
        paddingBottom: toRem(10),
        [theme.breakpoints.up('lg')]: {
            width: 'auto',
            display: 'inline-block'
        },
        '& li': {
            fontSize: toRem(14),
            display: 'inline',
            '&::after': {
                content: '"•"',
                margin: '0 5px'
            }
        },
        '& li:last-child': {
            '&::after': {
                content: '""',
                margin: 0
            }
        }
    },
    '& .BoatPrice': {
        marginTop: toRem(15),
        color: theme.colors.white,
        fontWeight: 700
    },

    '& .vat': {
        display: 'block',
        color: theme.colors.goldDark,
        textTransform: 'uppercase',
        fontSize: toRem(12),
        fontWeight: 400
    },

    '& .Arrow': {
        display: 'none',

        [theme.breakpoints.up('lg')]: {
            display: 'block',
            position: 'absolute',
            right: 40,
            bottom: 0,
            opacity: 0,
            transition: 'all 0.5s ease'
        }
    }
})

export default style
